import React from 'react';
import ReactDOM from 'react-dom';
import './styles/index.scss';
import Main from './Main';

ReactDOM.render(
  <React.StrictMode>
    <Main />
  </React.StrictMode>,
  document.getElementById('root')
);
